import { Component } from '@angular/core';
import { NewModalRef as ModalRef } from 'outshared-lib';

@Component({
    selector: 'ins-new-home-feedback-modal',
    templateUrl: './new-home-feedback.modal.html'
})
export class NewHomeFeedbackModal  {

    constructor(
        public modalRef: ModalRef<NewHomeFeedbackModal>
    ) {}

    public sluiten(): void {
        this.modalRef.close();
    }

    public verhuizen(): void {
        window.location.href = document.location.origin + `/mijn-verzekeringsmap/woonadres#/woonadres/wijzigen`;
    }

    public opzeggen(): void {
        this.modalRef.close();
    }
}
